import { render, staticRenderFns } from "./PessoaPoliticamenteExposta.vue?vue&type=template&id=2a958c1a&lang=pug"
import script from "./PessoaPoliticamenteExposta.vue?vue&type=script&lang=js"
export * from "./PessoaPoliticamenteExposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports